<template>
      <card>
        <list
          :columns="columns"
          :modalCreate="modalCreate"
          :removeLink="removeLink"
          :cardLink="cardLink"
          :isUpdate="true"
          :isAdd="false"
          :itemLink="itemLink"
          :setLink="setLink"
          :fields="fields"
          :searchDisable="true"
          @change="change"
          @changeFunction="changeFunction"
          v-model="val"
        />
      </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      val: [],
      modalCreate: "transaction",
      fields: [
       {
        col:' col-12 col-md-6',
        key: "value",
        label: "Бонус",
        type: "field",
        textType: "text",
      },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_transaction",
      itemLink: "transactions",
      setLink: "transactions",
      columns: [
        {
          key: "id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,

        },
               {
          key: "title",
          title: "Элемент",
        },
        {
          key: "value",
          title: "Бонус",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,

        },
          {
          key: "is_confirm",
          title: "Подтвержден",
        },
        {
          key: "barcode",
          title: "C/Н",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,

        },

        {
          key: "created_at",
          title: "Создан",
          dateTimeFormat: true,
        },
        {
            title:'Активатор',
            key:'activator',
            object:'phone',
            key_type:'activator_type',
        },
        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
